export const nameDictEn: Record<string, string> = {
  'ピアス・ルパージュ-カナダ': 'Pierce・LEPAGE-CAN',
  'ヨハネス・エルム-エストニア': 'Johannes・ERM-EST',
  'レオ・ノイゲバウアー-ドイツ': 'Leo・NEUGEBAUER-GER',
  'サンダー・スコッタイム-ノルウェー': 'Sander・SKOTHEIM-NOR',
  'カイル・ガーランド-アメリカ': 'Kyle・GARLAND-USA',
  'エイデン・デレルメ-プエルトリコ': 'Ayden・DELERME-PUR',
  'リンドン・ビクター-グレナダ': 'Lindon・VICTOR-GRN',
  'ダミアン・ワーナー-カナダ': 'Damian・WARNER-CAN',
  'ヒース・ボールドウィン-アメリカ': 'Heath・BALDWIN-USA',
  'スヴェン・ローセン-オランダ': 'Sven・ROOSEN-NED',
  'マケンソン・グレッティ-フランス': 'Makenson・GLETTY-FRA',
  'シモン・エハマー-スイス': 'Simon・EHAMMER-SUI',
  'ニクラス・カウル-ドイツ': 'Niklas・KAUL-GER',
  'ヤネク・オイグラネ-エストニア': 'Janek・ÕIGLANE-EST',
  'ハリソン・ウィリアムズ-アメリカ': 'Harrison・WILLIAMS-USA',
  'ティル・シュタインフォルト-ドイツ': 'Till・STEINFORTH-GER',
  'カレル・ティルガ-エストニア': 'Karel・TILGA-EST',
  'イェンテ・ハウッテケーテ-ベルギー': 'Jente・HAUTTEKEETE-BEL',
  'シアン・フェイ-中国': 'Xiang・FEI-CHN',
  'ホセ・フェレイラ-ブラジル': 'José・FERREIRA-BRA',
  'アントワーヌ・フェランティ-フランス': 'Antoine・FERRANTI-FRA',
  'オンドレイ・コペツキー-チェコ': 'Ondřej・KOPECKY-CZE',
  'ティム・ノヴァク-ドイツ': 'Tim・NOWAK-GER',
  'ヴィレム・ストラスキー-チェコ': 'Vilém・STRASKY-CZE',
  'ケンドリック・トンプソン-バハマ': 'Kendrick・THOMPSON-BAH',
  'オースティン・ウェスト-アメリカ': 'Austin・WEST-USA',

  // 女子
  'アンナ・ホール-アメリカ': 'Anna・HALL-USA',
  'ソフィー・ドクター-オランダ': 'Sofie・DOKTER-NED',
  'サガ・ヴァンニネン-フィンランド': 'Saga・VANNINEN-FIN',
  'タリア・ブルックス-アメリカ': 'Taliyah・BROOKS-USA',
  'ケイト・オコナー-アイルランド': "Kate・O'CONNOR-IRL",
  'マルタ・アラウホ-コロンビア': 'Martha・ARAUJO-COL',
  'ミシェル・アザリー-アメリカ': 'Michelle・ATHERLEY-USA',
  'アニック・ケーリン-スイス': 'Annik・KÄLIN-SUI',
  'アビゲイル・ポーレット-イギリス': 'Abigail・PAWLETT-GBR',
  'サンドリナ・シュプレンゲル-ドイツ': 'Sandrina・SPRENGEL-GER',
  'マリア・ビセンテ-スペイン': 'María・VICENTE-ESP',
  'ﾍﾞｱﾄﾘｰﾁｪ・ﾕｼｭｹｳﾞｨﾁｭｰﾃ-リトアニア': 'Beatričė・JUŠKEVIČIŪTĖ-LTU',
  'アドリアナ・シューベルト-ポーランド': 'Adrianna・SCHUBERT-POL',
  'ピッピ・ロッタ・エノク-エストニア': 'Pippi Lotta・ENOK-EST',
  'ヴァネッサ・グリム-ドイツ': 'Vanessa・GRIMM-GER',
  'トリ・ウェスト-オーストラリア': 'Tori・WEST-AUS',
  'ティマーラ・チャップマン-アメリカ': 'Timara・CHAPMAN-USA',
  'キャムリン・スミス-オーストラリア': 'Camryn・SMITH-AUS',
  'オリアナ・クラース-フランス': 'Auriana・KHLASS-FRA',
  'ナフィサトゥ・ティアム-ベルギー': 'Nafissatou・THIAM-BEL',
  'カタリナ・トンプソン-イギリス': 'Katarina・THOMPSON-GBR',
  'ｴﾏ・ｵｰｽﾃﾙｳｪｰﾍﾙ-オランダ': 'Emma・OOSTERWEGEL-NED',
  'スヴェヴァ・ジェレヴィーニ-イタリア': 'Sveva・GEREVINI-ITA',
  'ジェイド・オドウダ-イギリス': "Jade・O'DOWDA-GBR",
};
